import {
  FolderList,
  FolderItem,
  WrapperProfile,
  Username,
  RecentChatItem,
  RecentChats,
} from "./styled";
import { ReactComponent as AddIcon } from "../../assets/add.svg";
import { ReactComponent as RecentIcon } from "../../assets/recent.svg";
import { ReactComponent as SettingIcon } from "../../assets/setting.svg";
import { ReactComponent as LogoutIcon } from "../../assets/logout.svg";
import { ReactComponent as CalendarIcon } from "../../assets/calendar.svg";
import { ReactComponent as ProfileIcon } from "../../assets/user.svg";
import { ReactComponent as QAIcon } from "../../assets/qa.svg";
import defaultAvatar from "../../assets/default_avatar.png";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { getHistoryThunk } from "../../store/actions/chat.action";
import { useTopic } from "../../context/topicContext";
import { topics } from "../../constants/topics";
import { useNavigate } from "react-router-dom";
import { logout } from "../../store/actions/auth.action";
import { Tooltip, Dropdown } from "antd";

interface Props {
  openSidebar: boolean;
  closeAfterClicked?: boolean;
  setOpenSidebar: (value: React.SetStateAction<boolean>) => void;
}

const SidebarContent = ({ closeAfterClicked, setOpenSidebar }: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const features = [
    {
      name: "New Chat",
      icon: <AddIcon width={22} height={22} />,
      expandDisable: false,
      func: () => {
        navigate(`/chat`);
      },
    },
  ];
  const { recentsChat } = useAppSelector((state) => state.chatReducer);
  const { topic, setTopic } = useTopic();

  const fecthRecentSearch = async () => {
    try {
      await dispatch(getHistoryThunk()).unwrap();
    } catch (e) {}
  };

  const handleAction = useCallback(
    (action: any) => {
      if (!closeAfterClicked) {
        action?.();
        return;
      }

      action?.();
    },
    [closeAfterClicked]
  );

  useEffect(() => {
    fecthRecentSearch();
  }, [topic]);

  return (
    <FolderList>
      {features.map((folder, index) => (
        <Tooltip key={index} title={folder.name} placement="right">
          <FolderItem
            onClick={() => {
              handleAction(() => folder.func());
              if (closeAfterClicked) {
                setOpenSidebar(false);
              }
            }}
          >
            {folder.name}
          </FolderItem>
        </Tooltip>
      ))}
      <div
        style={{
          gap: "8px",
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
          padding: "20px 0",
        }}
      >
        <div
          style={{
            color: "#a1a1aa",
            fontSize: "14px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          Recent Chats
        </div>
        <RecentChats>
          {recentsChat?.items?.map((item, index) => (
            <RecentChatItem
              key={index}
              onClick={() => {
                navigate(`/chat/${item._id}`);
                if (closeAfterClicked) {
                  setOpenSidebar(false);
                }
              }}
            >
              {item.title}
            </RecentChatItem>
          ))}
        </RecentChats>
      </div>
    </FolderList>
  );
};

export default SidebarContent;
